import React, { useEffect, useState } from "react";
import { Route, useNavigate, useLocation } from "react-router-dom";
import roleJson from './role.json';
import { useCookies } from "react-cookie";
import LoadingSpinner from "../shared/LoadingSpinner";
const ProtectedRoute = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [cookies, setCookie] = useCookies();
    const location = useLocation();
    const navigate = useNavigate();
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    const logout = () => {
        setIsLoading(true);
        localStorage.clear();
        sessionStorage.clear();
        setTimeout(() => {
            setIsLoading(false);
            return navigate('/auth/login');
        }, 5000);
    }
    
    const checkUserToken = () => {
        setIsLoading(true);
        setTimeout(() => {
            const userToken = sessionStorage.getItem('authorization');
            if ([undefined, null].includes(userToken)) {
                setIsLoading(false);
                setIsLoggedIn(false);
                return navigate('/auth/login');
            } else {
            //     const statusCode = sessionStorage.getItem('statusCode');
            //     const isRole = roleJson.role.filter(e => e == statusCode).length > 0 ? true : false;
            //     if (isRole) {
            //         let data = require(`./role/${statusCode}.json`)
            //         if ([undefined, null, ''].includes(data)) {
            //             logout()
            //         } else {
            //             if (location.pathname == '/') {
            //                 setIsLoggedIn(true);
            //             } else {
            //                 let res = data.menu.filter(e => e.link == location.pathname);
            //                 let isMenu = res.length > 0 ? true : false;
            //                 if (isMenu) {
            //                     setIsLoggedIn(true);
            //                 } else {
                                setIsLoggedIn(true);
                                setIsLoading(false);
                                return navigate('/');
            //                 }
            //             }
            //         }
            //     } else {
            //         setIsLoggedIn(false);
            //         return navigate('/auth/login');
            //     }
            }
            setIsLoading(false);
        }, 2000);
    }

    useEffect(() => {
        checkUserToken();
    }, [isLoggedIn]);
    return (
        <React.Fragment>
            {isLoading ? (<LoadingSpinner />) : null}
            {
                isLoggedIn ? (
                    location.pathname == "/auth/login" ? (navigate('/')) : (props.children)
                ) : null
            }
        </React.Fragment>
    );
}
export default ProtectedRoute;